export default class Zone {
	constructor({cartodb_id, description, layer, name, the_geom, the_geom_webmercator, coordinates}) {
		this.cartodb_id = cartodb_id || 0;
		this.description = description || "";
		this.layer = layer || "";
		this.name = name || "type your zone here!";
		this.the_geom = the_geom ? the_geom : this.generateTheGeom({description, layer, name, coordinates});
		this.the_geom_webmercator = the_geom_webmercator
			? the_geom_webmercator
			: this.generateTheGeom({description, layer, name, coordinates});
	}

	/**
	 * Method to generete body for a geometry field cartodb
	 * @param {String} description some descrition text
	 * @param {String} layer code layer received from the service
	 * @param {String} name name of the layer received from the service
	 * @param {Array} coordinates array of geographic coordinate array with format like
	 *  [ [-91.23046875,45.460130637921],[-69.08203125,43.452918893555],[-88.2421875,32.694865977875],[-91.23046875,45.460130637921] ]
	 * @returns Object
	 */
	generateTheGeom({description, layer, name, coordinates}) {
		return {
			type: "Polygon",
			coordinates: [coordinates || []],
			crs: {type: name, properties: {name: "EPSG:4326"}},
			properties: {
				description,
				layer,
				name,
			},
		};
	}
}
